var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.showHeader)?_c('Header'):_vm._e(),_vm._v(" "),(_vm.showUserHeader)?_c('div',{staticClass:"router"},[_c('UserCenterHeader'),_vm._v(" "),_c('div',{staticClass:"user-center"},[_c('UserCenterTab'),_vm._v(" "),_c('router-view',{staticStyle:{"width":"100%"}})],1)],1):_c('router-view',{staticClass:"router"}),_vm._v(" "),_c('Footer')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-61bb6bec","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 